import { Checkbox } from "@/components/ui/checkbox";

function Row({ id, checked, onChange, children }) {
  return (
    <label htmlFor={id} className={`flex items-start gap-3 rounded-lg border p-3 cursor-pointer text-sm leading-relaxed ${checked ? "border-[#0A1F44]/40 bg-[#0A1F44]/5" : "border-slate-200 bg-white"}`}>
      <Checkbox id={id} data-testid={id} checked={checked} onCheckedChange={(v) => onChange(v === true)} className="mt-0.5" aria-required="true" />
      <span className="text-slate-800">{children}</span>
    </label>
  );
}

export default function PrivacyChecks({ value, onChange }) {
  return (
    <fieldset className="space-y-2.5" data-testid="privacy-checks">
      <legend className="text-sm font-medium text-slate-700 mb-1">Privacy (both required)</legend>
      <Row id="privacy-notice-check" checked={value.notice} onChange={(v) => onChange({ ...value, notice: v })}>
        I have read the{" "}
        <a href="/privacy" target="_blank" rel="noopener noreferrer" data-testid="privacy-notice-link"
           className="font-medium text-[#0A1F44] underline underline-offset-2" onClick={(e) => e.stopPropagation()}>
          Team Smith Hub Privacy Notice
        </a>{" "}
        and understand how my personal information is collected, used, stored and shared.
      </Row>
      <Row id="pbo-privacy-check" checked={value.pbo} onChange={(v) => onChange({ ...value, pbo: v })}>
        To protect PBO privacy, I agree to record only their name and appointment progress in Team Smith Hub. I will not enter their email address, phone number, home address or other personal details, including in notes.
      </Row>
    </fieldset>
  );
}
